import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { useSearchParams } from 'react-router-dom';

import { CustomAlert, CustomButton } from '../../../../../shared/uiComponents';
import { errorNormalizer } from '../../../../../shared/Helpers/functions';
import { Unarchive } from '../../../../../shared/Assets/svgIcons';

import { DispatchProperties } from '../../../../../redux/store';
import { getBehaviors, unArchiveBehavior } from '../../../../../redux/State/clientSlice/behaviorReductionSlice';
import { ArchiveClientBehaviorsProperties } from '../../../../../redux/API/ClientAPIHelpers/behaviorReductionProperties';
import { useScreenWidth } from '../../../../../shared/Helpers/hooks';

const UnarchiveContent = ({ data, onClose }: { data: ArchiveClientBehaviorsProperties; onClose: () => void }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const [params] = useSearchParams();

	const unarchiveHandler = () => {
		const includeArchived = params.get('includeArchivedBehavior') === 'true';
		const funderId = params.get('behaviorFunderId') || null;
		const clientId = data.clientId;
		dispatch(unArchiveBehavior(data))
			.then(unwrapResult)
			.then(() => {
				dispatch(getBehaviors({ clientId, includeArchived, funderId }));
				onClose();
			})
			.catch(errorNormalizer);
	};

	return (
		<>
			<CustomButton title="Yes" onClick={unarchiveHandler} className="marginBottom16" />
			<CustomButton title="Cancel" buttonType="secondaryGray" onClick={onClose} />
		</>
	);
};

const UnarchiveComponent = ({ data, onlyIcon }: { data: ArchiveClientBehaviorsProperties; onlyIcon?: boolean }) => {
	const [open, setOpen] = useState<boolean>(false);
	const closeHandler = () => setOpen(false);

	const screenWidth = useScreenWidth();
	const isMobile = screenWidth <= 768;

	return (
		<>
			<CustomButton
				title={onlyIcon || isMobile ? '' : 'Unarchive'}
				buttonType="secondaryGray"
				onClick={() => setOpen(true)}
				startIcon={<Unarchive />}
			/>
			<CustomAlert
				title="Do you want to unarchive?"
				open={open}
				onClose={closeHandler}
				Content={() => <UnarchiveContent data={data} onClose={closeHandler} />}
			/>
		</>
	);
};

export default UnarchiveComponent;
